import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    locales: [],
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.CONTAINERS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.CONTAINERS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.CONTAINERS_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.CONTAINERS_LOCALES_SUCCESS:
            return {
                ...state,
                locales: action.items
            };

        default:
            return state;
    }
};
